import i18n from "@/i18n/i18n";

export function getAll() {
  let c = [
    {
      value: -1,
      name: "All",
      text: `${i18n.global.t("enums.reportSource.All")}`,
    },
    {
      value: 0,
      name: "Local",
      text: `${i18n.global.t("enums.reportSource.Local")}`,
    },
  ];
  if (window.localStorage["hasOnlineOrder"] == "true") {
    c.push({
      value: 1,
      name: "Web",
      text: `${i18n.global.t("enums.reportSource.Web")}`,
    });
  }
  if (window.localStorage["hasUberEats"] == "true") {
    c.push({
      value: 2,
      name: "Ubereats",
      text: `${i18n.global.t("enums.reportSource.Ubereats")}`,
    });
  }
  if (
    window.localStorage["isERP"] == "true" ||
    window.localStorage["hasCloudElecInvoice"] == "true"
  ) {
    c.push({
      value: 4,
      name: "Backstage",
      text: `${i18n.global.t("enums.reportSource.Backstage")}`,
    });
  }
  if (window.localStorage["hasECPlatform"] == "true") {
    c.push({
      value: 6,
      name: "Showmore",
      text: `${i18n.global.t("enums.reportSource.Showmore")}`,
    });
  }
  return c;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
